const normalizeSpecies = (value) => String(value || '').trim().toLowerCase();
const freezeStages = (stages) => Object.freeze(stages.map((stage) => Object.freeze({ ...stage })));

/**
 * Existing route art assembled from the Myst client. Abra's authored flow is a
 * two-scene hunt: start in the pyramid (r4), then open onto the desert/coast
 * (r3) after the player has actually defeated a few targets.
 */
export const HUNT_MAP_STAGES = Object.freeze({
  abra: freezeStages([
    { afterDefeats: 0, tier: 4 },
    { afterDefeats: 8, tier: 3 },
  ]),
});

export function huntMapStageFor(species, defeated = 0) {
  const stages = HUNT_MAP_STAGES[normalizeSpecies(species)];
  if (!stages?.length) return null;
  const kills = Math.max(0, Math.floor(Number(defeated) || 0));
  let stage = 0;
  for (let index = 1; index < stages.length; index += 1) {
    if (kills >= stages[index].afterDefeats) stage = index;
  }
  return stage;
}

/** Returns null when the normal band art should be used. */
export function huntMapTierFor(band, species, defeated = 0) {
  const stage = huntMapStageFor(species, defeated);
  if (stage == null) return null;
  return HUNT_MAP_STAGES[normalizeSpecies(species)][stage].tier;
}

export function huntMapStageConfigFor(species, stage) {
  const stages = HUNT_MAP_STAGES[normalizeSpecies(species)];
  return stages?.[Math.max(0, Math.floor(Number(stage) || 0))] || null;
}
